import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { verify2FA } from '../api/auth/Auth'
import { isAuthenticated, login } from '../actions/authActions'
import { formatUsername, getTokenBody } from '../utils/utils'

function TwoFAVerify() {
  const [code, setCode] = useState('')
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    const type = sessionStorage.getItem('twofa_type')
    if (type !== 'pending') {
      navigate('/login')
    }
  }, [navigate])

  const onSubmit = async (e) => {
    e.preventDefault()
    const token = sessionStorage.getItem('twofa_token')
    try {
      const resp = await verify2FA(token, code)
      if (resp?.status === 200 && resp?.data?.token_type === 'Bearer') {
        // Clear temp
        sessionStorage.removeItem('twofa_token')
        sessionStorage.removeItem('twofa_type')
        const { sub, role } = getTokenBody()
        const greet = formatUsername(sub)
        dispatch(isAuthenticated())
        dispatch(login({ username: greet, role }))
        toast.success('Welcome back ' + greet)
        navigate('/')
      } else {
        toast.error('Verification failed')
      }
    } catch (e) {
      toast.error('Invalid code')
    }
  }

  return (
    <div className="font-neue-machina flex h-screen min-h-full bg-darkmode text-white items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-6">
        <h2 className="text-center text-2xl font-medium">Enter your 2FA code</h2>
        <form onSubmit={onSubmit} className="space-y-4">
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]{6}"
            maxLength={6}
            value={code}
            onChange={(e) => {
              const v = e.target.value.replace(/[^0-9]/g, '').slice(0, 6)
              setCode(v)
            }}
            placeholder="6-digit code"
            className="w-full bg-white p-3 rounded border border-gray-300 text-black placeholder:text-gray-500 caret-black focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
            required
          />
          <button type="submit" className="w-full bg-primary hover:bg-primary/80 rounded p-2">Verify</button>
        </form>
      </div>
    </div>
  )
}

export default TwoFAVerify
